<template>
<div v-loading="isLoading">
    <el-select v-if="isEditing" v-model="selectedContractId" @change="onContractChanged" placeholder="请选择" size="mini">
        <el-option v-for="item in contractList" :key="item.Id" :label="item.Description" :value="item.Id">
        </el-option>
    </el-select>
    <span v-if="!isEditing" :class="selectedContractName == '未签约'?'red':''">
        {{selectedContractName}}
        <span v-if="selectedContractName != '未签约'">{{hasContractAgreedText}}</span>
    </span>
</div>
</template>

<style lang="scss" scoped>
.red {
    color: red
}
</style>

<script>
import { getContractViewModelList } from "@/service/contract.service.js";
import {
    saveContractChange
} from "../../../service/finance.service.js"
import global_ from "../../../core/global";
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {},
    },
    data() {
        return {
            allContractList: [],
            contractList: [],
            selectedContractId: 0,
            selectedContractName: "",
            hasContractAgreed: false,
            isEditing: false,
            originalContractId: 0,
            originalContractName: "",
            originalHasContractAgreed: false,
            isContractListLoaded: false,
            isLoading: false
        };
    },
    components: {},
    created() { 
        this.init();
    },
    computed: {
        hasContractAgreedText: function(){
            let value = "";
            if (this.hasContractAgreed){
                value = "已签署";
            }else{
                value = "未签署";
            }
            return `(${value})`;
        }
    },
    methods: {
        init() {
            this.selectedContractId = this.data.ContractId;
            this.selectedContractName = this.data.ContractName;
            this.hasContractAgreed = this.data.HasContractAgreed;
            this.originalContractId = this.selectedContractId;
            this.originalContractName = this.selectedContractName;
            this.originalHasContractAgreed = this.hasContractAgreed;
        },
        loadContractList() {
            if (this.isContractListLoaded){
                return;
            }
            this.isLoading = true;
            let contractType = 2;
            if (!!this.data){
                contractType = this.GLOBAL.contractType.getValueByCourseType(this.data.CourseType);
            }
            
            getContractViewModelList(true).then(result => {
                if (!!result && result.success) {
                    this.allContractList = result.data.filter(i => i.ContractType == contractType);
                    this.contractList = this.allContractList.filter(i => i.Enable || i.Id == this.originalContractId);
                    //setContractViewModelListCache(this.contractList);
                    this.isContractListLoaded = true;
                }
                this.isLoading = false;
            }).catch(()=>{
                this.isLoading = false;
            });
        },
        onContractChanged() {
            let originalContract = this.contractList.filter(i => i.Id == this.originalContractId);
            let contract = this.contractList.filter(i => i.Id == this.selectedContractId);
            let isOriginalNew = false;
            let isNew = false;
            if (originalContract.length > 0){
                if (originalContract[0].IsStudentNew){
                    isOriginalNew = true;
                }
            }
            if (contract.length > 0){
                if (contract[0].IsStudentNew){
                    isNew = true;
                }
            }
     
            let message = "";
            if (isOriginalNew && !isNew){
                message = "是否要修改该学生的新生合同，这将会重置该学生的所有报名课程的合同，并会重置积分";
            }else if (!isOriginalNew && isNew){
                message = "是否要将该学生的合同类型修改为新生合同，这将会重置该学生的所有报名课程的合同为新生合同，并会重置积分";
            }else{
                this.saveContract();
            }

            if (!!message){
                this.$confirm(message, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                })
                .then(() => {
                    this.saveContract(true);
                })
                .catch(() => {
                    this.selectedContractId = this.originalContractId;
                    this.selectedContractName = this.originalContractName;
                    this.hasContractAgreed = this.originalHasContractAgreed;
                });
            }
        },
        saveContract(isReload) {
            let self = this;
            saveContractChange(this.data.Id, this.selectedContractId)
                .then(result => {
                    if (!!result && result.success) {
                        this.$message({
                            type: 'success',
                            message: '合同更新成功!'
                        });
                        self.originalContractId = self.selectedContractId;
                        self.originalContractName = self.contractList.filter(i => i.Id == self.selectedContractId)[0].Description;
                        self.originalHasContractAgreed = false; 
                        self.Reset();
                        if (isReload){
                            this.$emit("reload");
                        }
                    } else {
                        self.Reset();
                        this.$message({
                            type: 'error',
                            message: '合同更新失败! ' + result.message
                        });
                    }
                })
        },
        Reset() {
            this.isEditing = false;
            this.selectedContractId = this.originalContractId;
            this.selectedContractName = this.originalContractName;
            this.hasContractAgreed = this.originalHasContractAgreed;
        },
    },
    watch: {
        editLocation: function () {
             if (this.data.IsRefund){
                return;
            }
           
            if (this.editLocation && this.editLocation.columnLabel == "合同" && this.editLocation.rowIndex == this.data.Index) {
                this.isEditing = true;
                this.loadContractList();
            } else {
                this.isEditing = false;
            }
        },
        data:function(){
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/saleQueryContractCell.vue